<!-- @format -->

<template>
  <div class="ma-0 pa-0">
    <hide-at breakpoint="small">
      <!-- outer main card 1 -->
      <v-card
        elevation="5"
        rounded="lg"
        width="720"
        min-height="450"
        :style="{
          background: $vuetify.theme.themes[theme].background,
        }"
      >
        <!-- header start formate -->
        <v-row class="ma-0 pa-0">
          <v-col cols="8">
            <div style="display: flex">
              <h1 class="ml-3">{{ serverItems.title }}</h1>
            </div>
          </v-col>
          <v-col cols="4">
            <div style="display: flex">
              <v-spacer></v-spacer>

              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-x
                max-width="180"
              >
                <template v-slot:activator="{ on }">
                  <div
                    style="cursor: pointer"
                    v-on="on"
                    class="ma-0 pa-0 mt-2 ml-2"
                  >
                    <!-- <v-icon size="24" @click="getUsersFromTeam()">
                      mdi-account-plus-outline
                    </v-icon> -->
                    <v-avatar
                      size="20"
                      color="grey"
                      v-if="serverItems.assignedTo"
                      @click="getUsersFromTeam()"
                    >
                      <v-img
                        v-if="assignedProfileImage"
                        :src="assignedProfileImage"
                      >
                      </v-img>

                      <span class="white--text" v-if="!assignedProfileImage">{{
                        assignedProfileName
                      }}</span>
                    </v-avatar>

                    <v-icon
                      size="25"
                      v-if="serverItems.assignedTo === null"
                      @click="getUsersFromTeam()"
                      >mdi-account-circle-outline</v-icon
                    >
                  </div>
                </template>
                <v-card
                  elevation="0"
                  width="180"
                  rounded="xl"
                  height="210"
                  style="overflow-y: hidden"
                  class="ma-0 pa-0 pr-1"
                >
                  <v-text-field
                    v-model="searchUser"
                    class="pl-2 pr-2 pt-3 mx-2"
                    outlined
                    rounded
                    dense
                    append-icon="search"
                    label="Find Users"
                  >
                  </v-text-field>
                  <v-card
                    elevation="0"
                    width="160"
                    rounded="lg"
                    height="145"
                    style="overflow-x: hidden"
                    class="mt-n5 ml-2 mb-2 expand"
                  >
                    <div
                      class="ml-2 mb-n2"
                      style="display: flex; justify-content: start"
                      v-for="(item, index) in computedUsersInformation"
                      :key="index"
                    >
                      <p
                        @click="assignTaskToUser(item.username)"
                        style="cursor: pointer"
                      >
                        <v-avatar size="20" color="grey">
                          <v-img
                            v-if="item.profile.profile_image"
                            :src="item.profile.profile_image"
                          >
                          </v-img>

                          <span
                            class="white--text"
                            v-if="!item.profile.profile_image"
                            >{{
                              item.username[0] + "" + item.username[1]
                            }}</span
                          >
                        </v-avatar>
                        <!-- <v-icon
                          size="24"
                          class="mr-2"
                          
                        >
                          mdi-account-circle-outline </v-icon
                        > -->
                        {{ item.username }}
                      </p>
                    </div>

                    <!-- <v-row
                      v-for="(item, index) in usersInformation"
                      justify="center"
                      :key="index"
                    >
                      <v-col cols="4" class="ml-4">
                        <v-icon size="24"> mdi-account-plus-outline </v-icon>
                      </v-col>
                      <v-col cols="8" class="mt-n1">
                        <p>{{ item.username }}</p>
                      </v-col>
                    </v-row> -->
                  </v-card>
                </v-card>
              </v-menu>
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="230"
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-card
                  elevation="0"
                  width="230"
                  rounded="xl"
                  class="ma-0 pa-0"
                >
                  <div style="display: flex" class="ml-2">
                    <v-card
                      elevation="0"
                      rounded="xl"
                      width="60"
                      class="pl-2 ma-0 pt-1"
                    >
                      <!-- btn 0 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-exit-to-app </v-icon>
                      </v-btn>
                      <!-- btn 1 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-content-copy </v-icon>
                      </v-btn>
                      <!-- btn 2 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-sync </v-icon>
                      </v-btn>
                      <!-- btn3 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-check </v-icon>
                      </v-btn>
                      <!-- btn 4 -->
                      <v-btn icon>
                        <v-icon size="14">
                          mdi-arrow-down-bold-box-outline
                        </v-icon>
                      </v-btn>
                      <!-- btn 5 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-delete-outline </v-icon>
                      </v-btn>
                      <!-- btn 6 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-attachment </v-icon>
                      </v-btn>
                      <!-- btn 7 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-printer </v-icon>
                      </v-btn>
                      <!-- btn 8 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-airplane </v-icon>
                      </v-btn>
                    </v-card>
                    <v-divider
                      style="
                        margin-top: 4%;
                        margin-bottom: 2%;
                        height: 22em;
                        width: 3em;
                      "
                      vertical
                    ></v-divider>

                    <v-card
                      elevation="0"
                      rounded="xl"
                      width="170"
                      class="ma-0 pa-0 pt-2"
                    >
                      <p
                        class="pl-3"
                        style="font-size: 13px; padding-top: 0.1em"
                        v-for="(item, index) in dotitem"
                        :key="index"
                      >
                        {{ item.name }}
                      </p>
                    </v-card>
                  </div>
                </v-card>
              </v-menu>
              <v-btn icon>
                <v-icon @click="goBack()">mdi-close</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <!-- end of header -->

        <!-- horizontal divider 1 -->
        <!-- <div style="width:96%;" class="ml-2 mt-n2">
      <hr style="width:100%;height:1px;" />
    </div> -->
        <v-divider class="ml-2 mr-2 mt-n1"></v-divider>

        <div style="display: flex" class="mt-n7">
          <!-- innercard -1 left side -->
          <v-card
            elevation="0"
            width="500"
            min-height="395"
            color="transparent"
          >
            <!-- <p
              v-if="!serverItems.description"
              class="ml-8 mt-5"
              style="cursor: pointer"
              @click="addDescription()"
            >
              Add a note for this change card<v-icon class="ml-2" size="15"
                >mdi-pencil</v-icon
              >
            </p> -->
            <!-- <p
              v-if="serverItems.description"
              class="ml-8 mt-5"
              :v-bind="serverItems.description"
            >
              {{ serverItems.description }}
            </p> -->
            <v-textarea
              label="Add a note for this change card"
              :background-color="$vuetify.theme.themes[theme].background"
              class="ml-4 mt-3"
              style="font-size: 15px !important"
              auto-grow
              filled
              solo
              flat
              rows="1"
              row-height="20"
              dense
              v-model="serverItems.description"
              @keydown.enter.exact.prevent
              @keyup.enter.exact="updateDescription()"
              @keydown.enter.shift.exact="newlineDescription()"
            ></v-textarea>

            <div
              style="display: flex"
              class="ml-9"
              v-for="(item, index) in items"
              :key="index"
            >
              <v-btn icon @click="item.value = !item.value">
                <v-icon size="25" v-if="!item.value">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
                <v-icon size="25" v-if="item.value" color="blue">
                  mdi-checkbox-marked-circle-outline
                </v-icon>
              </v-btn>
              <p class="mt-2 ml-4" v-if="!item.value">{{ item.title }}</p>
              <p
                class="mt-2 ml-4"
                v-if="item.value"
                style="text-decoration: line-through"
              >
                {{ item.title }}
              </p>
            </div>

            <div style="display: flex" class="ml-8" v-if="field">
              <v-btn icon @click="check = !check">
                <v-icon size="25" v-if="!check">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
                <v-icon size="25" v-if="check">
                  mdi-checkbox-marked-circle-outline
                </v-icon>
              </v-btn>
              <v-text-field
                rounded
                v-model="text1"
                outlined
                clearable
                @keyup.enter="addItem1(text1)"
                dense
                class="mr-2"
              >
              </v-text-field>
            </div>

            <div
              class="ml-6"
              style="display: flex; cursor: pointer"
              @click="addInput()"
            >
              <v-icon>add </v-icon>
              <h4 class="ml-1">Add Checklist Item</h4>
            </div>

            <div class="mt-2 ml-3">
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="150"
              >
                <template v-slot:activator="{ on }">
                  <div
                    class="ml-3"
                    style="display: flex; cursor: pointer"
                    v-on="on"
                  >
                    <v-icon>mdi-attachment</v-icon>
                    <h4 class="ml-1">Add File</h4>
                  </div>
                </template>
                <v-card
                  elevation="0"
                  width="150"
                  rounded="xl"
                  height="100"
                  class="ma-0 pa-0"
                >
                </v-card>
              </v-menu>
            </div>

            <div class="mt-3">
              <v-text-field
                label="Comment"
                rounded
                clearable
                v-model="newComment.content"
                outlined
                @keyup.enter="addComment()"
                dense
                class="ml-4 mb-n4 mr-4"
              >
              </v-text-field>
            </div>

            <!-- horizontal divider 2-->
            <!-- <div style="width:94%;" class="ml-2 mt-4">
          <hr style="width:100%;height:1px;" />
        </div> -->
            <v-divider class="ml-2 mr-2 mt-3"></v-divider>

            <div style="display: flex" class="mt-7">
              <v-icon class="mt-n4 ml-5">mdi-plus</v-icon>
              <p class="ml-4">
                <strong>{{ serverItems.owner }}</strong> created this change
                card
              </p>
              <v-spacer></v-spacer>
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-x
                max-width="350"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    elevation="0"
                    class="mt-n2"
                    color="transparent"
                    >😃<v-icon color="grey">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <VEmojiPicker
                  v-show="true"
                  labelSearch="Search"
                  lang="pt-BR"
                  @select="onSelectEmoji"
                  style="height: 437px"
                  rounded="xl"
                />
              </v-menu>
            </div>
            <div style="display: flex">
              <p style="font-size: 10px" class="ml-6 mt-n3">3 min ago</p>
              <v-chip
                style=""
                v-if="valueInput"
                x-small
                class="ml-5 mt-n3"
                outlined
              >
                {{ valueInput }}
              </v-chip>
            </div>
            <v-btn
              class="ml-3 mt-6"
              rounded="xl"
              color="primary"
              @click="changeCardStatus('complete')"
              style="text-transform: none; font-size: 15px"
            >
              Complete Task
            </v-btn>
            <!-- div for comment show -->
            <div
              class="ma-0 pa-0 ml-3 mt-3 expand"
              style="max-height: 210px; margin-top: 7px; width: 95%"
            >
              <div
                style="
                  border: 1px solid grey;
                  border-radius: 20px;
                  max-height: auto;
                  margin-top: 7px;
                  width: 91%;
                "
                v-for="item in comments"
                class="ml-4"
                :key="item.content"
              >
                <p style="margin-left: 14px; margin-top: 8px">
                  {{ item.content }}
                </p>
              </div>
            </div>
          </v-card>

          <v-divider vertical class="mt-9 mb-3"></v-divider>

          <!-- card-3 right side-->
          <v-card
            elevation="0"
            width="210"
            min-height="395"
            color="transparent"
          >
            <!-- <date-picker v-model="date1" prepend-icon="calender" :config="options"></date-picker>  -->
            <div style="display: flex" class="pt-12">
              <v-spacer></v-spacer>

              <p class="mr-3">Add date</p>

              <!-- <v-spacer></v-spacer> -->
              <div class="ma-0 pa-0">
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-x
                  right
                  rounded="xl"
                  max-width="250px"
                  min-width="250px"
                >
                  <template v-slot:activator="{ on }">
                    <div class="mt-n2">
                      <v-btn icon v-model="date" persistent-hint v-on="on">
                        <v-icon>mdi-calendar</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <datepicker
                    v-model="date"
                    mode="dateTime"
                    :timezone="timezone"
                    class="ma-0 pa-0"
                  >
                  </datepicker>
                  <!-- <v-date-picker
                    class="ma-0 pa-0"
                    v-model="date"
                    no-title
                    mode="dateTime"
                    :timezone="timezone" 
                    @input="menu1 = false"
                  ></v-date-picker> -->
                </v-menu>
              </div>
            </div>

            <div style="text-align: center" class="mt-n3">
              <p style="font-size: 12px">Due on {{ date }}</p>
            </div>
            <!-- <div class="ml-2 mr-1">
              <v-date-picker mode="dateTime" v-model="date" /> -->
            <!-- <vue-ctk-date-time-picker   :noClearButton="true" append-icon="search"   input-size="sm"  v-model="value" ></vue-ctk-date-time-picker> -->
            <!-- </div> -->

            <div style="display: flex">
              <v-spacer></v-spacer>

              <p class="mr-3">Add Viewer</p>

              <div class="mt-n2">
                <v-menu
                  rounded="xl"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset--x
                  max-width="160"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon> mdi-eye-outline </v-icon>
                    </v-btn>
                  </template>
                  <v-card
                    elevation="0"
                    width="160"
                    rounded="xl"
                    height="200"
                    style="overflow-y: hidden"
                    class="ma-0 pa-0 pr-1"
                  >
                    <v-text-field
                      v-model="searchTag"
                      class="pl-2 pr-2 pt-3"
                      outlined
                      rounded
                      dense
                      append-icon="search"
                      label="Find Tags"
                    >
                    </v-text-field>
                    <v-card
                      elevation="0"
                      width="152"
                      rounded="xl"
                      height="200"
                      class="mt-n4 expand"
                    >
                      <v-row
                        v-for="(item, index) in itemsaccount"
                        :key="index"
                        class="mt-n8"
                      >
                        <v-col cols="3" class="pl-11 mt-n2">
                          <v-icon size="24"> mdi-account-plus-outline </v-icon>
                        </v-col>
                        <v-col cols="7" class="mt-n1 pl-6">
                          <p>{{ item.name }}</p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-card>
                </v-menu>
              </div>
            </div>

            <div style="display: flex">
              <v-spacer></v-spacer>
              <p class="mr-3">Add Tag</p>
              <div class="mt-n2">
                <v-menu
                  rounded="xl"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="210"
                  v-model="tagmenu"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon> mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card
                    elevation="0"
                    rounded="xl"
                    width="210"
                    style="overflow: hidden"
                    height="220"
                    class="ma-0 pa-0"
                  >
                    <div style="display: flex" class="pl-4 pt-2">
                      <h4 style="font-weight: 670">Assign Tags</h4>
                      <v-content class="pl-15">
                        <manageTag />
                      </v-content>
                    </div>
                    <v-text-field
                      v-model="searchTag"
                      class="pl-3 pr-3 pt-2"
                      outlined
                      rounded="lg"
                      dense
                      append-icon="search"
                      label="Find Tags"
                    >
                    </v-text-field>
                    <v-card
                      elevation="0"
                      width="190"
                      height="130"
                      style="overflow-x: hidden"
                      class="mt-n4 ml-2 pr-2 expand"
                    >
                      <v-row class="ml-2 mr-3">
                        <div v-for="(item, index) in localtags" :key="index">
                          <v-chip
                            x-small
                            @click="tagpass(item.title, item.color)"
                            class="ml-3 mt-2"
                            :color="item.color"
                            >{{ item.title }}
                          </v-chip>
                        </div>
                      </v-row>
                    </v-card>
                  </v-card>
                </v-menu>
                <!-- <v-menu
                  rounded="xl"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset--x
                  max-width="130"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon> mdi-tag-outline </v-icon>
                    </v-btn>
                  </template>
                  <v-card
                    elevation="0"
                    rounded="xl"
                    width="130"
                    class="ma-0 pa-0 pr-2"
                  >
                    <v-autocomplete
                      prepend-icon="search"
                      deletable-chips
                      label="Find Tags"
                    >
                    </v-autocomplete>
                    <v-chip
                      style="width: 6em; height: 1.2em"
                      class="ml-3"
                      color="primary"
                    >
                      important
                    </v-chip>
                    <v-chip
                      style="width: 6em; height: 1.2em"
                      class="ml-3"
                      color="secondary"
                    >
                      High Priority
                    </v-chip>
                    <div style="display: flex" class="pb-2 mt-2">
                      <v-chip
                        style="width: 6em; height: 1.2em"
                        class="ml-3"
                        color="warning"
                      >
                        Medium
                      </v-chip>
                      <v-chip
                        style="width: 5em; height: 1.2em"
                        class="ml-2"
                        color="success"
                      >
                        Now!
                      </v-chip>
                    </div>
                  </v-card>
                </v-menu> -->
              </div>
            </div>
            <v-card
              color="transparent"
              elevation="0"
              width="190"
              height="110"
              class="expand ml-2 mt-n4"
            >
              <v-row class="ml-2 mr-3">
                <div v-for="(item, index) in tagspass" :key="index">
                  <v-chip x-small class="ml-2 mt-1" :color="item.color"
                    >{{ item.title }}
                  </v-chip>
                </div>
              </v-row>
            </v-card>

            <!-- status -->
            <div style="text-align: right" class="pr-1"><p>Status</p></div>
            <div style="text-align: right" class="mt-n4">
              <v-menu
                v-model="menu"
                bottom
                right
                transition="scale-transition"
                origin="top left"
              >
                <template v-slot:activator="{ on }">
                  <v-chip
                    v-on="on"
                    small
                    :color="getStateColor(serverItems.status)"
                    dark
                    >{{ serverItems.status }}</v-chip
                  >
                </template>
                <v-list>
                  <v-list-item
                    v-for="item in state"
                    :key="item"
                    :disabled="loading"
                    @click="changeCardStatus(item)"
                  >
                    <v-list-item-title v-text="item"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <!-- status -->

            <!-- horizontal divider no:3  -->
            <!-- <div style="width:90%;" class="ml-2 mt-7">
          <hr style="width:100%;height:1px;" />
        </div> -->
            <v-divider class="ml-2 mr-2 mt-3"></v-divider>

            <div style="text-align: right" class="mr-2 mt-2">
              <h4>Created</h4>
              <p class="mt-n1">{{ serverItems.created_at }}</p>
            </div>

            <div style="text-align: right" class="mr-2 mt-n2">
              <h4>Updated</h4>
              <p class="mt-n1">{{ serverItems.created_at }}</p>
            </div>

            <div style="text-align: right" class="mr-2 mt-n2">
              <h4>ID</h4>
              <p class="mt-n1">
                <v-btn v-clipboard="() => taskLink" icon
                  ><v-icon>mdi-content-copy</v-icon></v-btn
                >{{ serverItems.slug }}
              </p>
            </div>
          </v-card>
        </div>
      </v-card>
    </hide-at>
    <show-at breakpoint="small">
      <!-- outer main card 1 -->
      <v-card elevation="5" rounded="xl" width="350" height="650">
        <!-- start innercard -1   -->
        <v-card
          elevation="0"
          class="ma-0 pa-0"
          width="350"
          height="57"
          color="#F5F5F5"
        >
          <div style="display: flex" class="ml-2">
            <div style="text-align: center" class="ml-2">
              <p class="mt-3" style="font-weight: 600">Created</p>
              <p class="mt-n4">{{ serverItems.created_at }}</p>
            </div>
            <v-spacer></v-spacer>
            <div style="text-align: center">
              <p class="mt-3" style="font-weight: 600">Updated</p>
              <p class="mt-n4">{{ serverItems.created_at }}</p>
            </div>
            <v-spacer></v-spacer>
            <div style="text-align: center">
              <p class="mt-3" style="font-weight: 600">ID</p>
              <p class="mt-n4">{{ serverItems.slug }}</p>
            </div>
            <v-spacer></v-spacer>
          </div>
        </v-card>
        <!-- end innercard -1  -->

        <div style="display: flex" class="mt-6">
          <v-icon size="32" class="ml-3" color="blue"
            >mdi-checkbox-marked-circle</v-icon
          >
          <h1 class="ml-3">Change Texture</h1>
        </div>
        <p class="ml-4 mt-4" style="font-size: 18px">
          Add a description for this
        </p>
        <p class="ml-4 mt-n4" style="font-size: 18px">change card</p>
        <!-- start small card grey absolute position-->
        <div style="position: absolute; top: 0; right: 0">
          <v-card
            elevation="0"
            color="#F5F5F5"
            width="45"
            height="180"
            rounded="xl"
            class="mr-2 mt-15"
          >
            <!--for close icon -->
            <v-btn icon class="ml-1 mt-1">
              <v-icon size="26" color="black"> mdi-close </v-icon>
            </v-btn>
            <!-- for calender -->
            <div class="ma-0 pa-0">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                rounded="xl"
                max-width="250px"
                min-width="250px"
              >
                <template v-slot:activator="{ on }">
                  <div class="mt-n2">
                    <v-btn
                      icon
                      v-model="date"
                      color="black"
                      persistent-hint
                      v-on="on"
                      class="ml-1 mt-4"
                    >
                      <v-icon color="black" size="22">mdi-calendar</v-icon>
                    </v-btn>
                  </div>
                </template>
                <datepicker
                  v-model="date"
                  mode="dateTime"
                  :timezone="timezone"
                  class="ma-0 pa-0"
                >
                </datepicker>
                <!-- <v-date-picker
                  class="ma-0 pa-0"
                  v-model="date"
                  no-title
                  @input="menu1 = false"
                ></v-date-picker> -->
              </v-menu>
            </div>
            <!-- for eye icon -->
            <div class="mt-2 ml-1">
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset--x
                max-width="140"
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon> remove_red_eye </v-icon>
                  </v-btn>
                </template>
                <v-card
                  elevation="0"
                  width="140"
                  rounded="xl"
                  height="200"
                  style="overflow-y: hidden"
                  class="ma-0 pa-0 pr-1"
                >
                  <v-autocomplete
                    prepend-icon="search"
                    deletable-chips
                    label="Find Viewer"
                  >
                  </v-autocomplete>
                  <v-card
                    elevation="0"
                    width="140"
                    rounded="xl"
                    height="200"
                    class="ma-0 pa-0 mt-n4 expand"
                  >
                    <v-row
                      v-for="(item, index) in itemsaccount"
                      :key="index"
                      class="mt-n8"
                    >
                      <v-col cols="3" class="pl-6">
                        <v-icon size="24"> mdi-account-plus-outline </v-icon>
                      </v-col>
                      <v-col cols="7" class="pt-4 pl-6">
                        <p>{{ item.name }}</p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-menu>
            </div>
            <!-- for tag icon -->
            <div class="mt-2 ml-1">
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset--x
                max-width="130"
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon> mdi-tag-outline </v-icon>
                  </v-btn>
                </template>
                <v-card
                  elevation="0"
                  rounded="xl"
                  width="130"
                  class="ma-0 pa-0 pr-2"
                >
                  <v-autocomplete
                    prepend-icon="search"
                    deletable-chips
                    label="Find Tags"
                  >
                  </v-autocomplete>
                  <v-chip
                    style="width: 6em; height: 1.2em"
                    class="ml-3"
                    color="primary"
                  >
                    important
                  </v-chip>
                  <v-chip
                    style="width: 6em; height: 1.2em"
                    class="ml-3 mt-2"
                    color="secondary"
                  >
                    High Priority
                  </v-chip>
                  <div style="display: flex" class="pb-2 mt-2">
                    <v-chip
                      style="width: 6em; height: 1.2em"
                      class="ml-3"
                      color="warning"
                    >
                      Medium
                    </v-chip>
                    <v-chip
                      style="width: 5em; height: 1.2em"
                      class="ml-2"
                      color="success"
                    >
                      Now!
                    </v-chip>
                  </div>
                </v-card>
              </v-menu>
            </div>
          </v-card>
        </div>
        <!-- end small card grey absolute position -->

        <!-- start innercard 2 -->
        <div class="mt-n5 expand">
          <v-card elevation="0" width="350" height="600" color="transparent">
            <div
              style="display: flex"
              class="ml-2"
              v-for="(item, index) in items"
              :key="index"
            >
              <v-btn icon @click="item.value = !item.value">
                <v-icon size="25" v-if="!item.value">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
                <v-icon size="25" v-if="item.value">
                  mdi-checkbox-marked-circle-outline
                </v-icon>
              </v-btn>
              <p class="mt-2 ml-3" v-if="!item.value">{{ item.title }}</p>
              <p
                class="mt-2 ml-3"
                v-if="item.value"
                style="text-decoration: line-through"
              >
                {{ item.title }}
              </p>
            </div>
            <div
              style="display: flex; max-width: auto"
              class="ml-2"
              v-if="field"
            >
              <v-btn icon @click="check = !check">
                <v-icon size="25" v-if="!check">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
                <v-icon size="25" v-if="check">
                  mdi-checkbox-marked-circle-outline
                </v-icon>
              </v-btn>
              <div>
                <v-text-field
                  rounded
                  v-model="text1"
                  outlined
                  clearable
                  @keyup.enter="addItem1(text1)"
                  dense
                  style="width: 14em"
                >
                </v-text-field>
              </div>
            </div>
            <div class="ml-n4">
              <v-btn text title @click="addInput()">
                <v-icon>add</v-icon><span text>Add Checklist Item</span>
              </v-btn>
            </div>
            <div class="mt-2 ml-n4">
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-x
                max-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn text title v-on="on">
                    <v-icon>mdi-attachment</v-icon><span text>Add File</span>
                  </v-btn>
                </template>
                <v-card
                  elevation="0"
                  width="150"
                  rounded="xl"
                  height="100"
                  class="ma-0 pa-0"
                >
                </v-card>
              </v-menu>
            </div>
            <v-divider class="ml-2 mr-2 mt-3"></v-divider>

            <p style="font-size: 10px" class="ml-12 mt-2">3 min ago</p>
            <div style="display: flex" class="mt-n2">
              <v-icon class="mt-n8 ml-5" color="black">mdi-plus</v-icon>
              <p class="ml-2">Timothy created this change card</p>
              <v-spacer></v-spacer>
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-x
                max-width="350"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    elevation="0"
                    class="mt-n2"
                    color="transparent"
                    >😃<v-icon color="black">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <VEmojiPicker
                  v-show="true"
                  labelSearch="Search"
                  lang="pt-BR"
                  @select="onSelectEmoji"
                  style="height: 437px"
                  rounded="xl"
                />
              </v-menu>
            </div>
            <div>
              <v-chip class="ml-5" style="min-width: 5em" outlined>
                {{ valueInput }}
              </v-chip>
            </div>
            <div class="mt-3">
              <v-text-field
                label="Comment"
                rounded
                clearable
                v-model="newComment.content"
                outlined
                @keyup.enter="addComment()"
                dense
                class="ml-4 mb-n4 mr-4"
              >
              </v-text-field>
            </div>
            <!-- div for comment show -->
            <div
              class="ma-0 pa-0 ml-3 mt-3 expand"
              style="max-height: 210px; margin-top: 7px; width: 95%"
            >
              <div
                style="
                  border: 1px solid grey;
                  border-radius: 20px;
                  max-height: auto;
                  margin-top: 7px;
                  width: 91%;
                "
                v-for="item in comments"
                class="ml-4"
                :key="item.content"
              >
                <p style="margin-left: 14px; margin-top: 8px">
                  {{ item.content }}
                </p>
              </div>
            </div>
          </v-card>
        </div>
        <!-- start of bottom card -->
        <v-card
          elevation="0"
          color="#F5F5F5"
          height="60"
          width="350"
          style="position: absolute; bottom: -15px"
        >
          <div style="display: flex" class="mt-3">
            <div>
              <v-btn
                class="ml-6"
                rounded="xl"
                color="primary"
                @click="changeCardStatus('complete')"
                style="text-transform: none; font-size: 15px"
              >
                Complete Task
              </v-btn>
            </div>

            <div class="ml-10">
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="230"
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon size="26" color="black">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-card
                  elevation="0"
                  width="230"
                  rounded="xl"
                  class="ma-0 pa-0"
                >
                  <div style="display: flex" class="ml-2">
                    <v-card
                      elevation="0"
                      rounded="xl"
                      width="60"
                      class="ma-0 pa-0"
                    >
                      <!-- btn 0 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-exit-to-app </v-icon>
                      </v-btn>
                      <!-- btn 1 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-content-copy </v-icon>
                      </v-btn>
                      <!-- btn 2 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-sync </v-icon>
                      </v-btn>
                      <!-- btn3 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-check </v-icon>
                      </v-btn>
                      <!-- btn 4 -->
                      <v-btn icon>
                        <v-icon size="14">
                          mdi-arrow-down-bold-box-outline
                        </v-icon>
                      </v-btn>
                      <!-- btn 5 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-delete-outline </v-icon>
                      </v-btn>
                      <!-- btn 6 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-attachment </v-icon>
                      </v-btn>
                      <!-- btn 7 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-printer </v-icon>
                      </v-btn>
                      <!-- btn 8 -->
                      <v-btn icon>
                        <v-icon size="14"> mdi-airplane </v-icon>
                      </v-btn>
                    </v-card>
                    <v-divider
                      style="
                        margin-top: 4%;
                        margin-bottom: 2%;
                        height: 22em;
                        width: 3em;
                      "
                      vertical
                    ></v-divider>
                    <v-card
                      elevation="0"
                      rounded="xl"
                      width="170"
                      class="ma-0 pa-0 pt-2"
                    >
                      <p
                        class="pl-3"
                        style="font-size: 13px; margin-top: 1%"
                        v-for="(item, index) in dotitem"
                        :key="index"
                      >
                        {{ item.name }}
                      </p>
                    </v-card>
                  </div>
                </v-card>
              </v-menu>
            </div>
          </div>
        </v-card>
        <!-- end of bottom card -->
      </v-card>
    </show-at>
  </div>
</template>

<script>
import { showAt, hideAt } from "vue-breakpoints";
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
// import Calendar from 'v-calendar/lib/components/calendar.umd'
import datepicker from "v-calendar/lib/components/date-picker.umd";
import axios from "axios";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
import manageTag from "../components/manageTag";
import { VEmojiPicker, emojisDefault, categoriesDefault } from "v-emoji-picker";
import store from "../store";
export default {
  name: "changetexture",
  components: {
    VEmojiPicker,
    showAt,
    hideAt,
    manageTag,
    //VueCtkDateTimePicker,
    // Calendar,
    datepicker,
  },
  //props

  //data
  data: function () {
    return {
      taskLink: "",
      timezone: "",
      value: null,
      date1: new Date(),
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false,
      },
      valueInput: "",
      tagspass: [],
      searchTag: "",
      tagmenu: false,
      localTags: [],

      slug: this.$route.params.slug,
      serverItems: [],
      created: "",

      state: ["open", "inProgress", "onHold", "complete"],
      selected: "inProgress",
      //date: new Date(),
      date: new Date().toISOString().substr(0, 10),
      text1: "",
      field: false,

      items: [],
      comments: [],
      newComment: {
        content: "",
      },

      dotitem: [
        { name: "Move To" },
        { name: "Duplicate" },
        { name: "Repeat" },
        { name: "Complete Task" },
        { name: "Archive" },
        { name: "Delete" },
        { name: "Copy Link" },
        { name: "Print" },
        { name: "Convert to Project" },
      ],

      // itemsaccount: [
      //   { filepng: "static/assets/images/marc.jpg", name: "ali" },
      //   { filepng: "static/assets/images/marc.jpg", name: "timy" },
      //   { filepng: "static/assets/images/marc.jpg", name: "lion" },
      //   { filepng: "static/assets/images/marc.jpg", name: "kinm" },
      //   { filepng: "static/assets/images/marc.jpg", name: "jon" },
      //   { filepng: "static/assets/images/marc.jpg", name: "jhkj" },
      //   { filepng: "static/assets/images/marc.jpg", name: "ali" },
      //   { filepng: "static/assets/images/marc.jpg", name: "timy" },
      //   { filepng: "static/assets/images/marc.jpg", name: "lion" },
      //   { filepng: "static/assets/images/marc.jpg", name: "kinm" },
      //   { filepng: "static/assets/images/marc.jpg", name: "jon" },
      //   { filepng: "static/assets/images/marc.jpg", name: "jhkj" },
      // ],
      itemsaccount: [],

      usersInformation: [],
      searchUser: "",

      assignedProfile: [],
    };
  },
  //computed
  computed: {
    localtags() {
      const search = this.searchTag.toLowerCase();

      if (!search) return store.state.tags;

      return store.state.tags.filter((item) => {
        const text = item.title.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },
    computedUsersInformation() {
      const search = this.searchUser.toLowerCase();

      if (!search) return this.usersInformation;

      return this.usersInformation.filter((item) => {
        const text = item.username.toLowerCase();
        return text.indexOf(search) > -1;
      });
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    assignedProfileImage() {
      if (this.assignedProfile.length > 0) {
        return this.assignedProfile[0].profile.profile_image;
      } else {
        return null;
      }
    },
    assignedProfileName() {
      if (this.assignedProfile.length > 0) {
        return (
          this.assignedProfile[0].username[0] +
          "" +
          this.assignedProfile[0].username[1]
        );
      } else {
        return null;
      }
    },
  },
  //created
  created() {
    console.log(this.slug);
  },

  //mounted
  mounted() {
    console.log(categoriesDefault);
    console.log("Total emojis:", emojisDefault.length);

    //this needs to be chane for online/offline
    var getUrl = window.location;
    //var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
    var baseUrl = getUrl.protocol + "//" + getUrl.host;

    axios
      .get(
        this.$abServerPath +
          "/api/glbfiles/augmentable/changeCard/" +
          this.slug +
          "/"
      )
      .then((response) => {
        this.serverItems = response.data;
        console.log(this.serverItems);

        this.serverItems.id = response.data.id;
        this.serverItems.slug = response.data.slug;
        this.serverItems.color = response.data.color;
        this.serverItems.dataposition = response.data.dataposition;
        this.serverItems.datanormal = response.data.datanormal;
        this.serverItems.title = response.data.title;
        this.serverItems.description = response.data.description;
        this.serverItems.filename = response.data.filename;
        this.serverItems.created_at = this.dateFormat(response.data.created_at);

        this.serverItems.updated_at = response.data.updated_at;

        this.serverItems.status = response.data.status;
        this.serverItems.complete = response.data.complete;

        this.serverItems.owner = response.data.owner;

        this.serverItems.assignedTo = response.data.assignedTo;
        if (response.data.assignedTo) {
          this.assignedToProfile(response.data.assignedTo);
        }

        //task link to share with other
        this.taskLink = "" + baseUrl + "/changespot/" + this.serverItems.slug;
      })
      .catch((error) => {
        console.log(error);
      });
  },

  //methods
  methods: {
    tagpass(x, y) {
      this.tagmenu = false;
      var obj = {
        title: "",
        color: "",
      };
      obj.title = x;
      obj.color = y;
      this.tagspass.unshift(obj);
      x = "";
      y = "";
    },
    dateFormat(x) {
      return (
        "" + x.slice(8, 10) + "." + x.slice(5, 7) + "." + x.slice(0, 4) + ""
      );
    },
    getStateColor(state) {
      if (state === "inProgress") return "light-blue";
      else if (state === "onHold") return "red";
      else if (state === "complete") return "green";
      else if (state === "inQueue") return "orange";
      else return "green";
    },
    onSelectEmoji(emoji) {
      this.valueInput += emoji.data;
    },

    addInput: function () {
      this.text1 = "";
      this.field = !this.field;
    },

    hasHistory() {
      return window.history.length > 2;
    },
    goBack() {
      if (this.hasHistory()) {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },

    addItem1(x) {
      var ss = {};
      ss.title = x;
      ss.value = false;
      if (x) {
        this.items.push(ss);
      }
      this.field = false;

      return this.items;
    },

    getUsersFromTeam() {
      this.usersInformation = [];

      axios
        .get(this.$abServerPath + "/api/glbfiles/glbgetusersfromgroup/", {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        })
        .then((response) => {
          var useritems = {};
          var userprofileitems = {};
          var i;
          var len;
          for (i = 0, len = response.data.length; i < len; i++) {
            //added for profile image
            if (response.data[i].profile[0].fields.profile_image) {
              response.data[i].profile[0].fields.profile_image =
                this.$abServerPath +
                "" +
                response.data[i].profile[0].fields.profile_image;
            }

            //added for profile image
            useritems = Object.assign(useritems, response.data[i].fields);
            userprofileitems = Object.assign(
              userprofileitems,
              response.data[i].profile[0].fields
            );
            useritems.profile = userprofileitems;
            this.usersInformation.push(useritems);

            useritems = {};
            userprofileitems = {};
          }
          console.log(this.usersInformation);

          // item.name = response.data;
          // this.itemsaccount.push(item);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addComment() {
      this.comments.unshift({
        content: this.newComment.content,
      });
      this.newComment.content = " ";
    },

    newlineDescription() {
      this.serverItems.description = `${this.serverItems.description}\n`;
    },
    updateServerItems() {
      console.log(this.serverItems.description);
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/augmentable/changeCard/" +
            this.serverItems.slug +
            "/"
        )
        .then((response) => {
          this.serverItems = response.data;
          console.log(this.serverItems);

          this.serverItems.id = response.data.id;
          this.serverItems.slug = response.data.slug;
          this.serverItems.color = response.data.color;
          this.serverItems.dataposition = response.data.dataposition;
          this.serverItems.datanormal = response.data.datanormal;
          this.serverItems.title = response.data.title;
          this.serverItems.description = response.data.description;
          this.serverItems.filename = response.data.filename;
          this.serverItems.created_at = this.dateFormat(
            response.data.created_at
          );

          this.serverItems.updated_at = response.data.updated_at;

          this.serverItems.status = response.data.status;
          this.serverItems.complete = response.data.complete;

          this.serverItems.owner = response.data.owner;

          this.serverItems.assignedTo = response.data.assignedTo;
          if (response.data.assignedTo) {
            this.assignedToProfile(response.data.assignedTo);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateDescription() {
      let formData = new FormData();
      formData.append("description", this.serverItems.description);
      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputtask/" +
            this.serverItems.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.updateServerItems();
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    assignTaskToUser(username) {
      let formData = new FormData();
      formData.append("assignedTo", username);
      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputtask/" +
            this.serverItems.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.updateServerItems();
        })
        .catch((error) => {
          console.log(error.data);
        });
    },

    assignedToProfile(username) {
      this.assignedProfile = [];
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/glbgetuserinformationandprofile/" +
            username +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          var useritems = {};
          var userprofileitems = {};
          var i;
          var len;
          for (i = 0, len = response.data.length; i < len; i++) {
            //added for profile image
            if (response.data[i].profile[0].fields.profile_image) {
              response.data[i].profile[0].fields.profile_image =
                this.$abServerPath +
                "" +
                response.data[i].profile[0].fields.profile_image;
            }

            //added for profile image
            useritems = Object.assign(useritems, response.data[i].fields);
            userprofileitems = Object.assign(
              userprofileitems,
              response.data[i].profile[0].fields
            );
            useritems.profile = userprofileitems;
            this.assignedProfile.push(useritems);

            useritems = {};
            userprofileitems = {};
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeCardStatus(x) {
      let formData = new FormData();
      formData.append("status", x);
      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputtask/" +
            this.serverItems.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          console.log("SUCCESS!!");

          axios
            .get(
              this.$abServerPath +
                "/api/glbfiles/augmentable/changeCard/" +
                this.serverItems.slug +
                "/"
            )
            .then((response) => {
              this.serverItems = response.data;
              console.log(this.serverItems);

              this.serverItems.id = response.data.id;
              this.serverItems.slug = response.data.slug;
              this.serverItems.color = response.data.color;
              this.serverItems.dataposition = response.data.dataposition;
              this.serverItems.datanormal = response.data.datanormal;
              this.serverItems.title = response.data.title;
              this.serverItems.description = response.data.description;
              this.serverItems.filename = response.data.filename;
              this.serverItems.created_at = this.dateFormat(
                response.data.created_at
              );

              this.serverItems.updated_at = response.data.updated_at;

              this.serverItems.status = response.data.status;
              this.serverItems.complete = response.data.complete;

              this.serverItems.owner = response.data.owner;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.expand::-webkit-scrollbar {
  width: 5px;
}
.expand {
  overflow-y: scroll;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}
.expand::-webkit-scrollbar-track {
  background: transparent;
}
.expand::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}

// .custom.v-textarea > .v-input__control > .v-input__slot:before {
//   border-style: none;
// }
// .custom.v-textarea > .v-input__control > .v-input__slot:after {
//   border-style: none;
// }

::v-deep .v-textarea textarea {
  line-height: 1.2rem;
}
</style>
